import React, { useEffect, useState } from "react";
import { LeadViewDetailsViewCampaignsInfoProps } from "./lead-view-details-view-campaigns-info.props";
import "./lead-view-details-view-campaigns-info.scss";
import AddToCampaignModal from "../../../../lead-actions/add-new-campaign/add-new-campiagn";
import CampaignTable from "../../../../../../common/components/modal-table/modal-table";
import {
  getLeadDetails,
  deleteCampaignAssign,
} from "../../../../../../api/lead";
import { editCampaignStatus } from "../../../../../../api/lead";
import DeleteDialog from "./delete-dialog/delete-assign-campiagn";
import StatusDialog from "./status-dialog/update-status-dialog";
import { useLogin } from "../../../../../../common/hooks/useUser";

const LeadViewDetailsViewCampaignsInfo: React.FC<
  LeadViewDetailsViewCampaignsInfoProps
> = (props: any) => {
  const {
    allLeadData,
    setLoading,
    setAlertMessage,
    setAlertType,
    setAlertOpen,
    disableEdit,
    leadDetails
  } = props;
  const [isCampaignModalOpen, setIsCampaignModalOpen] = useState(false);
  const [campiagnDetails, setCampaignDetails] = useState<any>(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [campaignToDelete, setCampaignToDelete] = useState<{
    leadId: number;
    associationId: number;
    name: string; // Change the type to ensure `name` is always a string
  } | null>(null);
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [selectedCampaignIdForStatusEdit, setSelectedCampaignIdForStatusEdit] =
    useState<number | null>(null);
  const [leadName, setLeadName] = useState("");
  const {tenantDetails}=useLogin();

  // Handle status edit
  const handleEditStatus = (campaign: any) => {
    setStatusFilter(campaign.membership_status || campaign.status);
    setSelectedCampaignIdForStatusEdit(campaign.campaign_lead_association_id);
    setOpenStatusDialog(true);
  };

  // Save status change
  const handleSaveStatus = async () => {
    if (selectedCampaignIdForStatusEdit != null) {
      setLoading(true);
      try {
        await editCampaignStatus(statusFilter, [
          selectedCampaignIdForStatusEdit,
        ], "Lead Details");
        setAlertMessage("Campaign Status Updated Successfully.");
        setAlertType("success");
        setAlertOpen(true);
        fetchLeadDetails();
      } catch (error) {
        setAlertMessage("Failed to update campaign status.");
        setAlertType("error");
        setAlertOpen(true);
      } finally {
        setLoading(false);
        setOpenStatusDialog(false);
        setSelectedCampaignIdForStatusEdit(null);
      }
    }
  };

  // Handle delete campaign
  const handleDeleteCampaign = (campaignId: number, associationId: number) => {
    const selected = campiagnDetails?.find(
      (item: any) => item.id === campaignId
    );
    const campaignName = selected?.name || ""; // Provide a default empty string if undefined
    setCampaignToDelete({
      leadId: allLeadData,
      associationId,
      name: campaignName, // name will always be a string
    });
    setOpenDeleteDialog(true);
  };

  const confirmDeleteCampaign = async () => {
    if (!campaignToDelete) return;
    setLoading(true);
    try {
      await deleteCampaignAssign(
        campaignToDelete.leadId,
        campaignToDelete.associationId,
        "Lead Details"
      );
      setAlertMessage("Campaign unassigned successfully.");
      setAlertType("success");
      setAlertOpen(true);
      fetchLeadDetails();
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message || "Failed to unassign campaign."
      );
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setLoading(false);
      setOpenDeleteDialog(false);
      setCampaignToDelete(null);
    }
  };
  const checkDisableField = () => {
  return (
    tenantDetails?.tenantType === "SuperTenant" &&
    leadDetails?.assigned_to &&
    !(leadDetails?.lead_status === "Closed-Lost")
  );
};

  // Fetch lead details
  const fetchLeadDetails = async () => {
    setLoading(true);
    try {
      const response = await getLeadDetails(allLeadData);
      const leadData = response?.data?.data;
      setLeadName(`${leadData?.first_name || ""} ${leadData?.middle_name || ""} ${leadData?.last_name || ""}`);
      setCampaignDetails(
        (response?.data?.data?.campaigns || []).map((item: any) => ({
          ...item.campaign,
          membership_status: item.lead_status_in_campaign,
          campaign_lead_association_id: item.id,
        }))
      );
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message ||
          "An error occurred while saving the lead."
      );
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchLeadDetails();
  }, [allLeadData]);

  const isTaskActionDisabled =
  leadDetails?.lead_status === "Closed-Won" ||
  checkDisableField();
  return (
    <div className="lead-view-details-view-campaigns-info">
      <div className="lead-view-details-view-campaigns-info-header">
        <div className="lead-view-details-view-campaigns-info-header-text">
          Campaigns
        </div>
        <div>
          <button
            className="lead-view-details-view-campaigns-info-header-button"
            onClick={() => setIsCampaignModalOpen(true)}
            disabled={disableEdit||leadDetails?.lead_status === "Closed-Won"}
          >
            Add to Campaigns
          </button>
        </div>
      </div>

      <div className="lead-view-details-view-campaigns-info-no-data">
        {campiagnDetails && campiagnDetails.length > 0 ? (
          <CampaignTable
            data={campiagnDetails}
            viewCampaign={true}
            onDelete={handleDeleteCampaign}
            onEditStatus={handleEditStatus}
            isTaskActionDisabled={isTaskActionDisabled}
          />
        ) : (
          <div className="no-record-text">No Record Found</div>
        )}
      </div>

      <AddToCampaignModal
        leadsIds={[allLeadData]}
        isOpen={isCampaignModalOpen}
        setMenuItems={() => {}}
        selectedActions={"addToCampaign"}
        handleMassActionMenuClose={() => setIsCampaignModalOpen(false)}
        multipleCampaign={true}
        onSave={() => {
          fetchLeadDetails();
          setIsCampaignModalOpen(false);
        }}
      />

      {/* Use DeleteDialog component */}
      <DeleteDialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        campaignToDelete={campaignToDelete}
        leadName={leadName}
        confirmDeleteCampaign={confirmDeleteCampaign}
      />

      {/* Use StatusDialog component */}
      <StatusDialog
        open={openStatusDialog}
        onClose={() => setOpenStatusDialog(false)}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        handleSaveStatus={handleSaveStatus}
      />
    </div>
  );
};

export default LeadViewDetailsViewCampaignsInfo;
